export const serverURL = "https://palegreen-ostrich-778209.hostingersite.com/";
export const localURL = "https://palegreen-ostrich-778209.hostingersite.com/";
